import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
};

const IconLayout: React.FC<IconProps> = ({ width = 18, height = 18 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
        >
            <g clip-path="url(#clip0_5923_22629)">
                <path
                    d="M15.6689 1.11719H2.91895C2.03906 1.11719 1.3252 1.83105 1.3252 2.71094V15.4609C1.3252 16.3408 2.03906 17.0547 2.91895 17.0547H15.6689C16.5488 17.0547 17.2627 16.3408 17.2627 15.4609V2.71094C17.2627 1.83105 16.5488 1.11719 15.6689 1.11719ZM2.91895 2.17969H15.6689C15.9611 2.17969 16.2002 2.41875 16.2002 2.71094V4.83594H2.3877V2.71094C2.3877 2.41875 2.62676 2.17969 2.91895 2.17969ZM9.8252 5.89844H16.2002V10.4141H9.8252V5.89844ZM2.3877 15.4609V5.89844H8.7627V15.9922H2.91895C2.62676 15.9922 2.3877 15.7531 2.3877 15.4609ZM15.6689 15.9922H9.8252V11.4766H16.2002V15.4609C16.2002 15.7531 15.9611 15.9922 15.6689 15.9922Z"
                    fill="#505050"
                />
            </g>
            <defs>
                <clipPath id="clip0_5923_22629">
                    <rect
                        width="17"
                        height="17"
                        fill="white"
                        transform="translate(0.793945 0.585938)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconLayout;
